import React, {Component} from 'react';
import {Form, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {DetailDialog as Picture} from "../../../resource/view/dialog/picture/picture";
import {DetailDialog as Video} from "../../../resource/view/dialog/video/video";
import PictureNormalFileItem from "../../../../components/upload/fileItem/PictureNormalFileItem";
import VideoNormalFileItem from "../../../../components/upload/fileItem/VideoNormalFileItem";
import {applicationName, converFileSize} from "../../../../utils";
import AudioNormalFileItem from "../../../../components/upload/fileItem/AudioNormalFileItem";
import OtherNormalFileItem from "../../../../components/upload/fileItem/OtherNormalFileItem";

class UploadFile extends BaseComponent {

    static defaultProps = {
        showAddBtn: true,
        height: 280
    };

    constructor(props) {
        super(props);
        this.state={
            fileList:props.itemValue || [],
            maxSize: 1024 * 1024 * 1024 * 2  // 2GB
        }
    }

    beforeUpload = async file => {
        let res = FILE_TYPE.find(item=>file.name.endsWith(item));
        let sizeValue =  file.size;
        return new Promise((resolve, reject) => {
            if(res){
                if(sizeValue < this.state.maxSize){
                    resolve()
                }else {
                    message.error(`文件大小不能超过${converFileSize(this.state.maxSize)}！`);
                    reject();
                }
            }else{
                message.error(`${file.name}文件格式不正确，只能上传以下格式${FILE_TYPE.join("，")}`);
                reject();
            }
        });
    };

    render() {
        let {fileList} = this.state;
        return (
            <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex",width:'100%',alignItems:"center"}}>
                <Scrollbars autoHeight autoHeightMax={this.props.height} style={{width:'642px'}} className="thrid">
                    <UploadWall
                        style={{marginTop:5,width:625}}
                        calssName={'interUpload'}
                        accept={"."+FILE_TYPE.join(",.")}
                        multiple={true}
                        action="/storage/uploadFile"
                        listType="picture-card"
                        fileList={fileList}
                        customRequest={new ChunkUpload({
                            checkFileURL:"/storage/checkFile",
                            checkChunkURL:"/storage/checkChunk",
                            uploadChunkURL:"/storage/uploadChunk",
                            chunkUploadOverURL:"/storage/chunkIsUploadOver",
                            mergeChunksURL:"/storage/mergeChunk",
                        }).start}
                        icons={[ "delete"]}
                        uploadBtnName={"上传文件"}
                        onChange={this.handleChangeFileList}
                        onRemove={this.handleRemoveFileList}
                        listType={"list"}
                        onDownload={(file)=>{
                            if(file.path.indexOf("?") === -1){
                                window.location.href = file.path + "?download=1";
                            }else{
                                window.location.href = file.path + "&download=1";
                            }
                        }}
                    />
                    <style>{`.ant-form-item-control{line-height:20px} `}</style>
                </Scrollbars>

            </Form.Item>
        )
    }

    handleChangeFileList = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                if(item.type &&  item.type.indexOf("video")>-1) {
                    item.url = info.file.response && info.file.response.thumbnailsPlayPath;
                } else {
                    item.url = info.file.response && info.file.response.path;
                }
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.isChunk = true;
                item.status = info.file.status;
                item.md5 = info.file.originFileObj && info.file.originFileObj.md5;
                item.id = info.file.response && info.file.response._id;
            }
            return item;
        });
        this.setState({fileList: info.fileList},()=>{
            this.props.callBack&& this.props.callBack( info.fileList)
        });
    };

    handleRemoveFileList = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.setState({
            fileList
        },()=>{
            this.props.callBack&& this.props.callBack(fileList)
        });
    };

    onDownload = (file) => {
        console.log(file.path);
        if(file.path) {
            this.request({
                url: file.path+"?download=1",
                method: "downloadGet",
                contentType: "json",
            });
        } else {
            console.log("文件path丢失")
        }
    };
}


export default UploadFile;
